export default "__VITE_ASSET__6016080a__"